const joinUrlPath = (...urlPaths) => urlPaths.join('/');

export default joinUrlPath;
